import { inject, Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { HttpClient, HttpErrorResponse, HttpResponse } from '@angular/common/http';
import { Observable, catchError, map, throwError } from 'rxjs';
import { DniRucResponse } from '@shared/models/util/dni-ruc-response.model';
import { ResponseWrapper } from '@shared/models';

const API_URL = environment.URL_SERVICIOSBACK;
const ENDPOINT_API_PERU = '/consulta';

@Injectable({
  providedIn: 'root',
})
export class ApiPeruService {
  private readonly API_URL_API_PERU = API_URL + ENDPOINT_API_PERU;
  private http = inject(HttpClient);

  consultarDni(numero: string): Observable<HttpResponse<ResponseWrapper<DniRucResponse>>> {
    return this.http
      .get<ResponseWrapper<DniRucResponse>>(`${this.API_URL_API_PERU}/dni/${numero}`, { observe: 'response' })
      .pipe(
        map((response: HttpResponse<ResponseWrapper<DniRucResponse>>) => response)
      );
  }

  consultarRuc(numero: string): Observable<HttpResponse<ResponseWrapper<DniRucResponse>>> {
    return this.http
      .get<ResponseWrapper<DniRucResponse>>(`${this.API_URL_API_PERU}/ruc/${numero}`, { observe: 'response' })
      .pipe(
        map((response: HttpResponse<ResponseWrapper<DniRucResponse>>) => response)
      );
  }
}

